import { type MergedCoupon } from '@cart-services/types'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { ScrollableList } from '../../../../components/ScrollableList/ScrollableList'
import { CouponFilterItem } from '../../product-catalog/components/CouponFilterItem'

const SKELETON_COUPON_COUNT = 3

const styles = stylex.create({
  couponWrapper: {
    alignSelf: 'stretch',
  },
  scrollableCouponList: {
    'scrollbarWidth': 'none',
    'height': 272,
    'overflowY': 'auto',
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
})

interface BrandPromoCouponListProps {
  coupons: MergedCoupon[]
  selectedCouponId: number | null
  onSelect: (couponId: number) => void
  isLoading: boolean
}

export const BrandPromoCouponList = (props: BrandPromoCouponListProps) => {
  const { coupons, selectedCouponId, onSelect, isLoading } = props
  const isMobile = useResponsive('mobile')

  if (isLoading) {
    if (isMobile) {
      return (
        <ScrollableList>
          {Array.from({ length: SKELETON_COUPON_COUNT }).map((_, index) => (
            <Box key={`coupon-skeleton-${index}`} flexShrink={0} width={280}>
              <Skeleton width="100%" height={80} />
            </Box>
          ))}
        </ScrollableList>
      )
    }
    return (
      <VStack gap={2}>
        {Array.from({ length: SKELETON_COUPON_COUNT }).map((_, index) => (
          <Skeleton key={`coupon-skeleton-${index}`} width="100%" height={80} />
        ))}
      </VStack>
    )
  }

  const handleSelect = (couponId: number) => {
    if (couponId === selectedCouponId) return
    onSelect(couponId)
  }

  if (isMobile) {
    return (
      <ScrollableList>
        {coupons.map(coupon => (
          <HStack key={coupon.coupon_id} flexShrink={0} width={280} minHeight={80} rootStyle={styles.couponWrapper}>
            <CouponFilterItem
              coupon={coupon}
              isSelected={coupon.coupon_id === selectedCouponId}
              onToggle={handleSelect}
            />
          </HStack>
        ))}
      </ScrollableList>
    )
  }

  return (
    <VStack gap={2} rootStyle={styles.scrollableCouponList}>
      {coupons.map(coupon => (
        <HStack key={coupon.coupon_id} minHeight={80} flexShrink={0}>
          <CouponFilterItem
            coupon={coupon}
            isSelected={coupon.coupon_id === selectedCouponId}
            onToggle={handleSelect}
          />
        </HStack>
      ))}
    </VStack>
  )
}
